import * as React from 'react'
import IndexLayout from "~layouts/IndexLayout"
import Head from "~components/Head"
import { withMicrocopy } from "~contexts/MicrocopyContext"
import { StaticQuery, graphql } from "gatsby"
import AiDevZone from '../components/AiDevZone'

const AiDevZoneMetadataStructured = ({ pageContext }) => {
  const endpointPath = "/reference/post-ai-extract-structured/"
  const codeSample = [
    {
      id: "2abac7fd-2c50-5b87-a81a-cd72d61d6e7e",
      language: "curl",
      // eslint-disable-next-line max-len
      code: "curl -i -L \"https://api.box.com/2.0/ai/extract_structured\" \r    -H \"content-type: application/json\" \r    -H \"authorization: Bearer <ACCESS_TOKEN>\" \r    -d \"{ \r        \"items\": [ \r          { \r            \"id\": \"12345678\", \r            \"type\": \"file\" \r          } \r        ], \r        \"metadata_template\": [ \r          { \r           \"template_key\": \"12345678\", \r           \"type\": \"metadata_template\", \r           \"scope\": \"\" \r          } \r        ], \r        \"fields\": [ \r          { \r            \"key\": \"name\", \r            \"description\": \"The name of the person.\", \r            \"displayName\": \"Name\", \r            \"prompt\": \"The name is the first and last name from the email address.\", \r            \"type\": \"string\", \r            \"options\": [ \r             { \r              \"key\": \"First Name\", \r             }, \r             { \r              \"key\": \"Last Name\" \r             } \r            ] \r          } \r        ]  \r      }\"  \r",
    },
  ]

  const demoUseCase = 'metadata'
  const demoFiles = [
    {
      id: "1511804164480",
      icon: "docx",
    },
    {
      id: "1495324886257",
      icon: "pdf",
    },
    {
      id: "1495321808917",
      icon: "pdf",
    },
  ]

  return (
    <StaticQuery
      query={query}
      render={(data) => {
        const endpointData = data.endpoints?.nodes.filter((element) => element.path === endpointPath)
        return (
          <IndexLayout>
            <Head title="Box AI Developer Zone, structured metadata extraction" />
            <AiDevZone
              codeSample={endpointData[0]?.samples ? endpointData[0]?.samples : codeSample}
              type={demoUseCase}
              demoFiles={demoFiles}
            />
          </IndexLayout>
        )
      }}
    />
  )
}

export default withMicrocopy(AiDevZoneMetadataStructured)

const query = graphql`
  query {
    endpoints: allEndpoint {
      nodes {
        id
        title
        path
        samples {
          id
          language
          code
        }
      }
    }
  }
`
